import React, { Children, FC, PropsWithChildren } from 'react';
import { Box } from '@mui/material';

export const PromotionalBannersLayout: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <Box
      sx={{
        my: {
          xs: 6,
          sm: 12,
        },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: {
          xs: 1,
          sm: 2,
          md: 3,
        },
      }}
    >
      {Children.map(children, (child) => (
        <Box sx={{ flex: 1 }}>{child}</Box>
      ))}
    </Box>
  );
};
